function statusChecker(status) {
    return status === 'success' ? true : false
}